import { trimSearch } from '@xmatters/common/utils/searchUtil';

export const RESET_SOURCE_FILTER = 'RESET_SOURCE_FILTER';
export const ACTIVE_SOURCE_FILTER = 'ACTIVE_SOURCE_FILTER';

export const SOURCEFILTER_SEARCH = 'SOURCEFILTER_SEARCH';
export const SOURCEFILTER_SEARCH_START = `${SOURCEFILTER_SEARCH}_START`;
export const SOURCEFILTER_SEARCH_SUCCESS = `${SOURCEFILTER_SEARCH}_SUCCESS`;
export const SOURCEFILTER_SEARCH_FAIL = `${SOURCEFILTER_SEARCH}_FAIL`;

export const resetSourceFilters = sourceFilters => ({
  type: RESET_SOURCE_FILTER,
  payload: sourceFilters,
});

export const setActiveSourceFilters = sourceFilters => ({
  type: ACTIVE_SOURCE_FILTER,
  payload: sourceFilters,
});

export const getSearchSources = search => {
  const params = {};

  const trimmedSearchText = trimSearch(search);
  if (trimmedSearchText.length >= 2) {
    params.search = trimmedSearchText;
    params.operand = 'AND';
    params.fields = ['NAME'];
  }
  return {
    type: SOURCEFILTER_SEARCH,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/plans`,
      method: 'get',
      params,
    },
    payload: {},
  };
};
